import { pluralize } from '@common/services/pluralize-service';

function humanizeHours(value: number): string {
  if (value < 24) {
    return `${value} ${pluralize('hour', value)}`;
  }

  const days = Math.floor(value / 24);
  const hours = value % 24;

  const humanizedDays = `${days} ${pluralize('day', days)}`;
  const humanizedHours = `${hours} ${pluralize('hour', hours)}`;

  return hours === 0 ? humanizedDays : `${humanizedDays} and ${humanizedHours}`;
}

export function tierHumanizeVisibilityOffset(delayInHours?: number) {
  if (delayInHours === 0) {
    return '0 hours (No Delay)';
  }

  if (!delayInHours) {
    return '';
  }

  return humanizeHours(delayInHours);
}
